import { Button, Grid, Paper } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const LandingPage = () => {
    const history = useHistory();

    const sendToExercise = (role)=>{
        history.push(`/${role}/exercise/0`)

    }

    return (
        <div>
            <Grid container spacing={2} justify="center" lg={6} md={8} xs={12} style={{margin: '0 auto'}}>
                <Grid item xs={12} md={12}>
                    <div style={{ display: 'flex' }}>
                        <h2 style={{width: '100%'}}>Welcome! Please choose the role you've applied for to continue</h2>
                    </div>
                </Grid>
                <Grid item xs={12} md={4} elevation={2}>
                    <Paper style={{height: 200, padding: 16, display: 'grid'}}>
                        <h2>Sales</h2>
                        <h3>Solutions Architect</h3>
                        <Button color="secondary" variant="contained" onClick={()=>sendToExercise('sa')}>Continue</Button>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} elevation={2}>
                <Paper style={{height: 200, padding: 16, display: 'grid'}}>
                        <h2>Sales</h2>
                        <h3>Pre-Sales Solutions Engineer</h3>
                        <Button color="secondary" variant="contained" onClick={()=>sendToExercise('se')}>Continue</Button>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} elevation={2}>
                    <Paper style={{height: 200, padding: 16, display: 'grid'}}>
                        <h2>CS</h2>
                        <h3>Customer Success Engineer</h3>
                        <Button align-self="end" color="secondary" variant="contained" onClick={()=>sendToExercise('cse')}>Continue</Button>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}

export default LandingPage;